// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

@keyframes animationgradienttitle {
  0% {
      background-position: 0 1600px;
  }
  100% {
      background-position: 1600px 0;
  }
}


h1 {
  margin: 0;
}

.c-article {
  margin-top: 1rem;
  text-align: start;
  margin-left: 2rem;
}

.c-article__header {
  position: relative;
}

.c-article__title {
  font-family: 'Scope One', serif;
  font-size: 3em;
  color: #ffffff;
  background: -webkit-linear-gradient(left,#FFFFFF ,  pink);
  background-size: 1600px 200px;
  -webkit-background-clip: text;
  /* background-image: linear-gradient(45deg, #4b97f3, #a8bdea); */
  -webkit-text-fill-color: transparent;
  animation-duration: 3s;
  animation-name: animationgradienttitle;
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

.u-font-lora {
  font-family: 'Lora', serif;
  font-size: 1.5em;
  font-weight: 400;
}


.box {
    height: 100px;
    /* background:; */
    border-radius: 10px !important;
    color: white;
    font-weight: 700;
    cursor: pointer;
  }

  .active{
    transition: background 0.15s ease-in-out;
    color: #28a745;
  }


  .active-click{
    background: rgba(40, 167, 69, 0.125) !important;
    animation-delay: 100ms;
    transition: background 0.15s ease-in-out;
     
  }

  .prospect {
    /* background: rgba(0, 123, 255, 0.25) !important; */
    color: #007bff;
    font-weight: 600;

  }

  .prospect-click{
        background: rgba(0, 123, 255, 0.25) !important;
    animation-delay: 100ms;
    transition: background 0.15s ease-in-out;
  }

  .onboard{
    /* background: rgba(108, 117, 125, 0.125); */
  color: #6c757d;
  }

  .onboard-click{
    background: rgba(108, 117, 125, 0.325);
    animation-delay: 100ms;
    transition: background 0.15s ease-in-out;
  }

  .inactive{

    color: rgba(255, 7, 58, 0.6);
  }


  .inactive-click{
       background: rgba(255, 7, 58, 0.125);
    animation-delay: 100ms;
    transition: background 0.15s ease-in-out;
  }


  /* .clients{
    background:rgba(70, 367, 99, 0.225);
    color: white;
    opacity: 1;
  } */

  .cards-min{
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    height: inherit;
  }


  .cards-main{
    /* background:black; */
    /* opacity: 0.3; */
    border-radius: 10px !important;
    width: 80%;
    margin-top:0px !important;


  }

  .cards{
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-row-gap: 20px;
    grid-column-gap:20px ;
    margin-top: 40px;
    /* margin: auto !important; */
    
  }


  .map{
    padding-left: 200px;
    padding-top: 10px;
  }




  .map-tool{
    margin-top: 20px;
  }


  .map-tool-div{
    display: flex;
    width: 90%;
    justify-content: space-between;
  }
  .map-tool-div>div:nth-child(3){
    display: flex;
    flex-direction: column;
    color: rgba(150, 115, 185, 0.7333333333);
    text-align: right;
    animation-delay: 500ms;
    width: 100px;

  }

  .map-tool-div>div:nth-child(3)>div:nth-child(2){
    font-size: 25px;
  }


  .map-tool-div>div:nth-child(1)>h1{
    background: rgba(226, 48, 40, 0.062745098);
    border-radius: 5px;
    cursor: pointer;
    padding: 0.25rem;
    color: #e23028;
    max-width: 20rem;

  }

  .modality-check{
    font-size: 15px;
  }


  .map-tool-detail{
    margin-top: 30px;
    text-align: start;
    width: 90%;
      display: flex;
      justify-content:space-between ;
      align-items: center;
  }


  .toolti-map{
    display: flex;
  }

  .toolti-map>svg{
    width: 18px;
    height: 18px;
    margin-right: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }


  .prospect-tool{
    fill: #007bff;
  }


  .onboard-tool{
    fill:#6c757d
  }


  .active-tool{
  fill:#28a745
  }

  .inactive-tool{
    fill:rgba(255, 7, 58, 0.1882352941)
    }

    .cards-min>div:nth-child(2){
      font-size: 23px;
    }

    .modality-check{
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      margin: auto;
      color: darkgray;
      /* display: grid; */
    

    }
  

    .modality-check>div>input{
      margin-right: 10px;
      margin-left: 10px;
      cursor: pointer;
    }

    input[type="checkbox"] {
      /* ...existing styles */
      /* display: grid;
      place-content: center; */
      color: #28a745;
    }
    
    input[type="checkbox"]::before {
      content: "";
      width: 0.65em;
      height: 0.65em;
      transform: scale(0);
      transition: 120ms transform ease-in-out;
      box-shadow: inset 1em 1em var(--form-control-color);
    }
    
    `, "",{"version":3,"sources":["webpack://./src/components/Home.css"],"names":[],"mappings":";;AAEA;EACE;MACI,6BAA6B;EACjC;EACA;MACI,6BAA6B;EACjC;AACF;;;AAGA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,cAAc;EACd,yDAAyD;EACzD,6BAA6B;EAC7B,6BAA6B;EAC7B,gEAAgE;EAChE,oCAAoC;EACpC,sBAAsB;EACtB,sCAAsC;EACtC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,wCAAwC;IACxC,cAAc;EAChB;;;EAGA;IACE,+CAA+C;IAC/C,sBAAsB;IACtB,wCAAwC;;EAE1C;;EAEA;IACE,oDAAoD;IACpD,cAAc;IACd,gBAAgB;;EAElB;;EAEA;QACM,8CAA8C;IAClD,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,4CAA4C;EAC9C,cAAc;EACd;;EAEA;IACE,sCAAsC;IACtC,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;;IAEE,4BAA4B;EAC9B;;;EAGA;OACK,mCAAmC;IACtC,sBAAsB;IACtB,wCAAwC;EAC1C;;;EAGA;;;;KAIG;;EAEH;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;EACjB;;;EAGA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;IACV,yBAAyB;;;EAG3B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;;EAE/B;;;EAGA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;;;;EAKA;IACE,gBAAgB;EAClB;;;EAGA;IACE,aAAa;IACb,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,wCAAwC;IACxC,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;;EAEd;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;;EAElB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;MACR,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;EACvB;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;;EAGA;IACE,aAAa;EACf;;;EAGA;IACE;EACF;;;EAGA;EACA;EACA;;EAEA;IACE;IACA;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,gDAAgD;MAChD,YAAY;MACZ,eAAe;MACf,mBAAmB;;;IAGrB;;;IAGA;MACE,kBAAkB;MAClB,iBAAiB;MACjB,eAAe;IACjB;;IAEA;MACE,uBAAuB;MACvB;8BACwB;MACxB,cAAc;IAChB;;IAEA;MACE,WAAW;MACX,aAAa;MACb,cAAc;MACd,mBAAmB;MACnB,uCAAuC;MACvC,mDAAmD;IACrD","sourcesContent":["\n\n@keyframes animationgradienttitle {\n  0% {\n      background-position: 0 1600px;\n  }\n  100% {\n      background-position: 1600px 0;\n  }\n}\n\n\nh1 {\n  margin: 0;\n}\n\n.c-article {\n  margin-top: 1rem;\n  text-align: start;\n  margin-left: 2rem;\n}\n\n.c-article__header {\n  position: relative;\n}\n\n.c-article__title {\n  font-family: 'Scope One', serif;\n  font-size: 3em;\n  color: #ffffff;\n  background: -webkit-linear-gradient(left,#FFFFFF ,  pink);\n  background-size: 1600px 200px;\n  -webkit-background-clip: text;\n  /* background-image: linear-gradient(45deg, #4b97f3, #a8bdea); */\n  -webkit-text-fill-color: transparent;\n  animation-duration: 3s;\n  animation-name: animationgradienttitle;\n  animation-iteration-count: infinite;\n  animation-fill-mode: forwards;\n}\n\n.u-font-lora {\n  font-family: 'Lora', serif;\n  font-size: 1.5em;\n  font-weight: 400;\n}\n\n\n.box {\n    height: 100px;\n    /* background:; */\n    border-radius: 10px !important;\n    color: white;\n    font-weight: 700;\n    cursor: pointer;\n  }\n\n  .active{\n    transition: background 0.15s ease-in-out;\n    color: #28a745;\n  }\n\n\n  .active-click{\n    background: rgba(40, 167, 69, 0.125) !important;\n    animation-delay: 100ms;\n    transition: background 0.15s ease-in-out;\n     \n  }\n\n  .prospect {\n    /* background: rgba(0, 123, 255, 0.25) !important; */\n    color: #007bff;\n    font-weight: 600;\n\n  }\n\n  .prospect-click{\n        background: rgba(0, 123, 255, 0.25) !important;\n    animation-delay: 100ms;\n    transition: background 0.15s ease-in-out;\n  }\n\n  .onboard{\n    /* background: rgba(108, 117, 125, 0.125); */\n  color: #6c757d;\n  }\n\n  .onboard-click{\n    background: rgba(108, 117, 125, 0.325);\n    animation-delay: 100ms;\n    transition: background 0.15s ease-in-out;\n  }\n\n  .inactive{\n\n    color: rgba(255, 7, 58, 0.6);\n  }\n\n\n  .inactive-click{\n       background: rgba(255, 7, 58, 0.125);\n    animation-delay: 100ms;\n    transition: background 0.15s ease-in-out;\n  }\n\n\n  /* .clients{\n    background:rgba(70, 367, 99, 0.225);\n    color: white;\n    opacity: 1;\n  } */\n\n  .cards-min{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    /* align-items: center; */\n    height: inherit;\n  }\n\n\n  .cards-main{\n    /* background:black; */\n    /* opacity: 0.3; */\n    border-radius: 10px !important;\n    width: 80%;\n    margin-top:0px !important;\n\n\n  }\n\n  .cards{\n    width: 100%;\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    grid-row-gap: 20px;\n    grid-column-gap:20px ;\n    margin-top: 40px;\n    /* margin: auto !important; */\n    \n  }\n\n\n  .map{\n    padding-left: 200px;\n    padding-top: 10px;\n  }\n\n\n\n\n  .map-tool{\n    margin-top: 20px;\n  }\n\n\n  .map-tool-div{\n    display: flex;\n    width: 90%;\n    justify-content: space-between;\n  }\n  .map-tool-div>div:nth-child(3){\n    display: flex;\n    flex-direction: column;\n    color: rgba(150, 115, 185, 0.7333333333);\n    text-align: right;\n    animation-delay: 500ms;\n    width: 100px;\n\n  }\n\n  .map-tool-div>div:nth-child(3)>div:nth-child(2){\n    font-size: 25px;\n  }\n\n\n  .map-tool-div>div:nth-child(1)>h1{\n    background: rgba(226, 48, 40, 0.062745098);\n    border-radius: 5px;\n    cursor: pointer;\n    padding: 0.25rem;\n    color: #e23028;\n    max-width: 20rem;\n\n  }\n\n  .modality-check{\n    font-size: 15px;\n  }\n\n\n  .map-tool-detail{\n    margin-top: 30px;\n    text-align: start;\n    width: 90%;\n      display: flex;\n      justify-content:space-between ;\n      align-items: center;\n  }\n\n\n  .toolti-map{\n    display: flex;\n  }\n\n  .toolti-map>svg{\n    width: 18px;\n    height: 18px;\n    margin-right: 10px;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n  }\n\n\n  .prospect-tool{\n    fill: #007bff;\n  }\n\n\n  .onboard-tool{\n    fill:#6c757d\n  }\n\n\n  .active-tool{\n  fill:#28a745\n  }\n\n  .inactive-tool{\n    fill:rgba(255, 7, 58, 0.1882352941)\n    }\n\n    .cards-min>div:nth-child(2){\n      font-size: 23px;\n    }\n\n    .modality-check{\n      display: grid;\n      grid-template-columns: repeat(4, minmax(0, 1fr));\n      margin: auto;\n      color: darkgray;\n      /* display: grid; */\n    \n\n    }\n  \n\n    .modality-check>div>input{\n      margin-right: 10px;\n      margin-left: 10px;\n      cursor: pointer;\n    }\n\n    input[type=\"checkbox\"] {\n      /* ...existing styles */\n      /* display: grid;\n      place-content: center; */\n      color: #28a745;\n    }\n    \n    input[type=\"checkbox\"]::before {\n      content: \"\";\n      width: 0.65em;\n      height: 0.65em;\n      transform: scale(0);\n      transition: 120ms transform ease-in-out;\n      box-shadow: inset 1em 1em var(--form-control-color);\n    }\n    \n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
